import React from "react";
import styles from "./History.module.css";
import Footer from "../../components/ui/Footer";
import Navbar from "../../components/ui/Navbar";
import { NavLink, Outlet } from "react-router-dom";
import Menu from "../../components/ui/Menu";
import { useSelector } from "react-redux";

function History(props) {
  const userDetails = useSelector((state) => state.userData.personalInfo);

  const accountType = useSelector(
    (state) => state.userData.loginData.account_type
  );

  return (
    <div>
      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="History" setShowMenu={props.setShowMenu} />
      <div className={styles.body}>
        <div className={styles.body_header}>
          <h1>Wallet balance:</h1>
          <p> ₦{Number(userDetails?.wallet?.balance || 0).toLocaleString()}</p>
        </div>
        <div className={styles.body_inner}>
          <div className={styles.body_inner_header}>
            {window.location.pathname === "/pin-history/sold-pins" ||
            window.location.pathname === "/pin-history/exported-pins"
              ? [
                  ...(accountType === "DISTRIBUTOR"
                    ? [
                        {
                          to: "/pin-history/sold-pins",
                          label: "Sold Pins",
                          exact: true,
                        },
                      ]
                    : []),
                  {
                    to: "/pin-history/exported-pins",
                    label: "Exported Pins",
                    exact: true,
                  },
                  {
                    to: "/pin-history/bought-pins",
                    label: "Bought Pins",
                    exact: true,
                  },
                ].map(({ to, label, exact }) => (
                  <NavLink
                    key={to}
                    to={to}
                    end={exact}
                    className={({ isActive }) =>
                      `${styles.link} ${isActive ? styles.active : ""}`
                    }
                  >
                    {label}
                  </NavLink>
                ))
              : [
                  ...(accountType !== "DISTRIBUTOR"
                    ? [{ to: "/history", label: "Orders", exact: true }]
                    : []),
                  { to: "/history/credit", label: "Credit" },
                  { to: "/history/debit", label: "Debit" },
                ].map(({ to, label, exact }) => (
                  <NavLink
                    key={to}
                    to={to}
                    end={exact}
                    className={({ isActive }) =>
                      `${styles.link} ${isActive ? styles.active : ""}`
                    }
                  >
                    {label}
                  </NavLink>
                ))}
          </div>

          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default History;
